import { render, staticRenderFns } from "./ReturnExpand.vue?vue&type=template&id=ea26dd4e&scoped=true&"
import script from "./ReturnExpand.vue?vue&type=script&lang=js&"
export * from "./ReturnExpand.vue?vue&type=script&lang=js&"
import style0 from "./ReturnExpand.vue?vue&type=style&index=0&id=ea26dd4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea26dd4e",
  null
  
)

export default component.exports